import { Mail, StickyNote, CalendarDays, ListChecks, AlarmClock, Award, User as UserIcon } from "lucide-react";
import { NOTIFY_TYPE_RECORD_KEYS } from "@/react/hooks/entityHooks/useEntityOwnership";

// Notification type content configuration
export const NOTIFY_TYPE_COLUMN_CONTENT = {
  [NOTIFY_TYPE_RECORD_KEYS.general]: {
    icon: Mail,
    title: "General",
    description: (entityName: string) => `Notify when this ${entityName}'s general data changes (name, type, etc.)`,
    color: "text-blue-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.notes]: {
    icon: StickyNote,
    title: "Notes",
    description: (entityName: string) => `Notify when this ${entityName}'s notes are added or updated`,
    color: "text-purple-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.schedule]: {
    icon: CalendarDays,
    title: "Schedule",
    description: (entityName: string) => `Notify when this ${entityName} is scheduled or rescheduled`,
    color: "text-green-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.checklist]: {
    icon: ListChecks,
    title: "Checklists",
    description: (entityName: string) => `Notify when this ${entityName}'s checklists are updated`,
    color: "text-orange-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.reminder]: {
    icon: AlarmClock,
    title: "Reminders",
    description: (entityName: string) => `Notify when this ${entityName}'s reminders are triggered`,
    color: "text-red-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.incentive]: {
    icon: Award,
    title: "Incentives",
    description: (entityName: string) => `View and earn this ${entityName}'s incentives`,
    color: "text-yellow-500"
  },
  [NOTIFY_TYPE_RECORD_KEYS.assignment]: {
    icon: UserIcon,
    title: "Assignments",
    description: (entityName: string) => `View this ${entityName}'s assignments on Swivu's Workforce application`,
    color: "text-cyan-500"
  }
};

// Exclude types by entity
// Note: Resources support all notification types (including assignment and incentive)
// Tasks and Clients exclude assignment and incentive types
export const EXCLUDE_NOTIFY_TYPE_BY_ENTITY_TYPE: Record<string, string[]> = {
  clientId: [NOTIFY_TYPE_RECORD_KEYS.assignment, NOTIFY_TYPE_RECORD_KEYS.incentive],
  taskId: [NOTIFY_TYPE_RECORD_KEYS.assignment, NOTIFY_TYPE_RECORD_KEYS.incentive],
  resourceId: [] // Resources support all notification types
};